import useContextHook from "./useContextHook";
import { languageContext } from "context/language/LanguagesContext";
import { themeContext } from "context/theme/ThemeContext";
import { navbarToggleContext } from "context/navbar/NavbarContext";
import { mediaContext } from "context/media_player/MediaPlayerContext";

export const useLanguagesContext = () => {
    const language = useContextHook(languageContext);
    return language;
};

export const useThemeContext = () => {
    const theme = useContextHook(themeContext);
    return theme;
};

export const useNavbarContext = () => {
    const navbarContext = useContextHook(navbarToggleContext);
    return navbarContext;
};

export const useMediaPlayerContext = () => {
    const mediaPlayerContext = useContextHook(mediaContext);
    return mediaPlayerContext;
};
